import { c as _c } from "react/compiler-runtime";
import { Button, TextInput } from '@mantine/core';
import { useForm, zodResolver } from '@mantine/form';
import React from 'react';
import { zEmailForm } from './SignInCommon';
import { sb } from 'utils/db';
import { showNotification } from '@mantine/notifications';
const zPassword = zEmailForm.pick({
  password: true
});
export const ChangePasswordForm = t0 => {
  const $ = _c(23);
  const {
    close,
    buttonLabel: t1,
    onChanged,
    email
  } = t0;
  const buttonLabel = t1 === undefined ? "Sign-in with a password" : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      initialValues: {
        password: ""
      },
      validate: zodResolver(zPassword),
      validateInputOnBlur: true
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    isValid,
    isDirty,
    values: t3,
    setFieldError,
    getInputProps
  } = useForm(t2);
  const {
    password
  } = t3;
  let t4;
  if ($[1] !== email) {
    t4 = email && <div className=""><span className="opacity-60">Changing password for </span> <span className="font-semibold">{email}</span></div>;
    $[1] = email;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== getInputProps) {
    t5 = getInputProps("password");
    $[3] = getInputProps;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t5) {
    t6 = <TextInput autoFocus={true} placeholder="enter a new password" type="password" autoComplete="new-password" {...t5} />;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== isDirty || $[8] !== isValid) {
    t7 = !isDirty() || !isValid;
    $[7] = isDirty;
    $[8] = isValid;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== close || $[11] !== onChanged || $[12] !== password || $[13] !== setFieldError) {
    t8 = e => {
      e.preventDefault();
      sb.auth.updateUser({
        password
      }).then(t9 => {
        const {
          error
        } = t9;
        if (error) {
          setFieldError("password", error.message);
        } else {
          if (onChanged) {
            onChanged();
          } else {
            showNotification({
              message: "password changed"
            });
          }
          close();
        }
      });
    };
    $[10] = close;
    $[11] = onChanged;
    $[12] = password;
    $[13] = setFieldError;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== buttonLabel || $[16] !== t7 || $[17] !== t8) {
    t9 = <div className="flex justify-end"><Button type="submit" variant="filled" disabled={t7} onClick={t8}>{buttonLabel}</Button></div>;
    $[15] = buttonLabel;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t4 || $[20] !== t6 || $[21] !== t9) {
    t10 = <form className="space-y-4">{t4}{t6}{t9}</form>;
    $[19] = t4;
    $[20] = t6;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
};